import {ISODate} from "./date"
export const NEVER = new ISODate(3000, 1, 1)
